// extracted by mini-css-extract-plugin
export var bodyRow = "_ej-d";
export var cardColumns = "_ej-e";
export var ellipsesOverflow = "_ej-2";
export var flatBottomCorners = "_ej-3";
export var flatTopCorners = "_ej-4";
export var headerActionsDropdown = "_ej-f";
export var headerBottomRow = "_ej-c";
export var headerTopRow = "_ej-b";
export var orderDetailsWrapper = "_ej-0";
export var orderInfoContainer = "_ej-1";
export var productDetails = "_ej-9";
export var productImage = "_ej-5";
export var responsiveTable = "_ej-8";
export var shipmentContainer = "_ej-a";
export var tableBottomLeft = "_ej-6";
export var tableBottomRight = "_ej-7";
export var trackingLink = "_ej-g";